import React, { useContext } from 'react';

import { OnboardingMintMappingContext } from '../../../../context/onboarding/OnboardingMintMappingContext';
import { ButtonWithLoading } from '../../../common/Button';
import { View } from '../../../common/View';
import { Checkbox } from '../../../forms';

type OnboardingMintAccountsProps = {
  onNext: () => void;
};

export function OnboardingMintAccounts({
  onNext,
}: OnboardingMintAccountsProps) {
  const { accounts, setAccounts } = useContext(OnboardingMintMappingContext);

  return (
    <View>
      <View
        style={{
          fontWeight: 'bold',
          alignSelf: 'center',
          fontSize: 18,
          marginBottom: 20,
        }}
      >
        Which accounts will impact your budget?
      </View>
      <View style={{ maxWidth: '500px' }}>
        Please select all accounts that will inform your budget and enable your
        expense tracking, like your checking account.
        <br />
        <br />
        The rest of the accounts will be marked as “off-budget”, meaning you
        would like to keep track of these accounts alongside your budget
        planning, but they do not directly inform your budget (for example, a
        mortgage).
      </View>
      <View
        style={{
          maxHeight: '40vh',
          overflowY: 'auto',
          marginTop: 16,
          marginBottom: 16,
        }}
      >
        {accounts?.map((account, index) => (
          <View
            key={account.name}
            style={{
              flexDirection: 'row',
              flex: 'none',
              alignItems: 'center',
              marginBottom: 4,
            }}
          >
            <Checkbox
              id={account.name}
              checked={account.forBudget}
              onChange={e => {
                const _accounts = [...accounts];

                _accounts[index].forBudget = (
                  e.target as HTMLInputElement
                ).checked;
                setAccounts(_accounts);
              }}
            />
            <label htmlFor={account.name} style={{ userSelect: 'none' }}>
              {account.name}
            </label>
          </View>
        ))}
      </View>
      <ButtonWithLoading
        type="primary"
        disabled={!accounts.find(acc => acc.forBudget)}
        onClick={() => onNext()}
      >
        Next
      </ButtonWithLoading>
    </View>
  );
}
